const intlTelInput = require('intl-tel-input');
const tomSelect = require('tom-select');
import '../../../node_modules/intl-tel-input/build/js/utils.js';

class PhonePrefixField {
  constructor (wrapper) {
    this.wrapper = $(wrapper);
    try {
      this.phonePrefixObj = JSON.parse(decodeURIComponent(this.wrapper.data('prefixes')));
    }catch (e){
      return;
    }
    this.phonePrefixSelect = this.wrapper.find('.input-phone-prefixes');
    this.phoneInput = this.wrapper.find('.input-phone');
    this.form = this.wrapper.closest('form');

    if(this.phonePrefixObj.error) return;
    this.run();
  }

  run(){
    this.tomSelectObj = this.initTomSelect(this.phonePrefixSelect);
    this.intlTelInputObj = this.initIntlTelInput(this.phoneInput[0]);

    this.cleave = new Cleave(this.phoneInput, {
      phone: true,
      phoneRegionCode: this.findCountryByPrefix(this.phonePrefixObj.selected)
    });

    if(this.phoneInput.val() !== '') this.handleChange(null);

    this.tomSelectObj.on('change', (e) => this.handleSelectChange(e));
    this.phoneInput.on('input', (e)=>this.handleChange(null, e));
    this.phonePrefixSelect.on('custom:changePrefix', (e, country, silent) => {
      if(!!country && country.length>0) {
        this.tomSelectObj.setValue(country, silent);
      }
    });
  }

  initIntlTelInput(telInput){
    let prefixObj = this.phonePrefixObj;
    let selected = this.findCountryByPrefix(prefixObj.selected);
    let settings = {
      allowDropdown: false,
      initialCountry: selected.toLowerCase(),
      nationalMode: true,
      utilsScript: "../../../node_modules/intl-tel-input/build/js/utils.js?1234567890",
      separateDialCode: false
    }
    return intlTelInput(telInput, settings);
  }

  initTomSelect(select){
    let prefixObj = this.phonePrefixObj;
    let settings = {
      maxItems: 1,
      maxOptions: null,
      valueField: 'value',
      labelField: 'label',
      searchField: ['country', 'label'],
      sortField: 'label',
      options: prefixObj.country,
      create: false,
      placeholder: select.data('searchPlaceholder'),
      plugins: ['dropdown_input'],
      items: [prefixObj.selected]
    };
    return new tomSelect(select, settings);
  }
  handleSelectChange(country){
    this.handleChange(country);
    this.phoneInput.parsley().validate();
  }
  handleChange(country, e){
    let inputPref = this.wrapper.find('[name=inputPhonePrefixes]');
    if(!!country && country.length>0) {
      let selected = this.findCountryByPrefix(country);
      this.intlTelInputObj.setCountry(selected.toLowerCase());
      this.cleave.setPhoneRegionCode(selected);
      inputPref.val(this.tomSelectObj.getValue());
    }

    if(this.intlTelInputObj.getNumber() !== ''){
      if(this.intlTelInputObj.isValidNumber()){
        this.phoneInput.attr('data-parsley-phone', 'valid');
        this.phoneInput.parsley().validate();
      }else{
        this.phoneInput.attr('data-parsley-phone', 'invalid');
      }
    } else {
      e && e.stopImmediatePropagation();
      this.phoneInput.parsley().removeError('required', { updateClass: true });
      this.phoneInput.removeClass('is-valid-input');
      this.phoneInput.removeClass('is-invalid-input');
      this.phoneInput.closest('label').removeClass('is-invalid-label');
    }
  }

  findCountryByPrefix(country){
    let selected = this.phonePrefixObj.country.find((el)=>{
      return country === el.value;
    });
    return selected.label.substring(0, 2);
  }
}


class PhonePrefix {
  run () {
    Parsley.addValidator('phone', {
      requirementType: 'string',
      validateString: function(value, requirement) {
        return requirement === 'valid';
      }
    });
    this.wrappers = [];
    let phoneNumberWrapper = $('.phone-number-wrapper');
    if (phoneNumberWrapper.length > 0) {
      [...phoneNumberWrapper].forEach((wrapper) => {
        this.wrappers.push(new PhonePrefixField(wrapper));
      });
    }
  }
}

const phonePrefix = new PhonePrefix();
export default phonePrefix;



// WEBPACK FOOTER //
// ./assets/scripts/components/phonePrefix.js